export default __webpack_public_path__ + "static/media/white_manual.157f4043.svg";